module.exports = __webpack_public_path__ + "files/586f9484a968d89780e35d9603e0ab6a.png";